import { createAction, props } from "@ngrx/store";
import { ErrorModel, GuidResult, Result, TariffDto, TariffDtoPagedResponse } from "../../../core/cms-api/models";


export const loadTariffList = createAction('[Tariff] Load tariff list');
export const loadTariffListSuccess = createAction('[Tariff] Load tariff list success', props<{ tariffsResponse: TariffDtoPagedResponse }>());
export const loadTariffListFailure = createAction('[Tariff] Load tariff list failure', props<{ error: ErrorModel }>());

export const changeTariffPagination = createAction('[Tariff] tariff pagination changed', props<{ pageIndex: number, pageSize: number }>());
export const changeTariffPaginationSuccessful = createAction('[Tariff] tariff pagination changed successful');

export const insertNewTariff = createAction('[Tariff] Insert new tariff', props<{ createTariffRequest: TariffDto }>());
export const insertNewTariffSuccess = createAction('[Tariff] Insert new tariff success', props<{ result: GuidResult }>());
export const insertNewTariffFailure = createAction('[Tariff] Insert new tariff failure', props<{ error: ErrorModel }>());

export const updateTariff = createAction('[Tariff] Update tariff', props<{ rfidGrupId: string, updateTariffRequest: TariffDto }>())
export const updateTariffSuccess = createAction('[Tariff] Update tariff success', props<{ result: Result }>());
export const updateTariffFailure = createAction('[Tariff] Update tariff failure', props<{ error: ErrorModel }>());

export const tariffMarkedAsStandard = createAction('[Tariff] Tariff marked standard', props<{tariffId: string}>());

export const deleteNewTariff = createAction('[Tariff] Delete tariff', props<{ tariffId: string }>());
export const deleteNewTariffSuccess = createAction('[Tariff] Delete tariff success', props<{ result: Result }>());
export const deleteNewTariffFailure = createAction('[Tariff] Delete tariff failure', props<{ error: ErrorModel }>());